import * as React from 'react';
import { useCallback } from 'react';
import { Button } from 'antd';
import { UserOutlined } from '@ant-design/icons/lib';
import { colors } from '../../assets/constStyles';

interface IButtonLogin{
  disabled?: boolean
  withIcon?: boolean
}

export const ButtonLogin: React.FC<IButtonLogin> = ({ disabled = false, withIcon }) => {
  const onClick = useCallback(() => {
    console.log(onClick);
  }, []);

  return <>
        {/* <Link to={paths.LOGIN} onClick={onClick}> */}
            <Button type={'primary'}
                    disabled={disabled}
                    icon={withIcon && <UserOutlined />} aria-label={'Login'}
                    style={{ minWidth: '80px', backgroundColor: colors.colorRed }}>LOGIN</Button>
        {/* </Link> */}
    </>;
};
